export const USERS_INITIATE_RESET_PASSWORD = 'CS/USERS_INITIATE_RESET_PASSWORD';
export const USERS_INITIATE_RESET_PASSWORD_SUCCESS = `${USERS_INITIATE_RESET_PASSWORD}_SUCCESS`;
export const USERS_INITIATE_RESET_PASSWORD_ERROR = `${USERS_INITIATE_RESET_PASSWORD}_ERROR`;
export const RESET_PASSWORD_CONFIRMATION = 'CS/RESET_PASSWORD_CONFIRMATION';
export const RESET_PASSWORD_CONFIRMATION_SHOW = `${RESET_PASSWORD_CONFIRMATION}_SHOW`;
